import en from './rewards.en';

const enConfig = { en };

export default enConfig;
